export default __webpack_public_path__ + "static/media/collection-list-arrow-up.29d56ade.svg";